import { httpService } from "./httpService";

/**
 *
 * @template T
 * @typedef {import('types/commonTypes').HttpResult<T>} HttpResult
 */

/**
 * @typedef {import('types/commonTypes').AuthResponse} AuthResponse
 * @param {{ username: string; password: string; }} props
 * @returns  {HttpResult<AuthResponse>}
 */
export const login = async ({ username, password }) =>
  httpService({
    url: "/auth/login",
    options: {
      method: "POST",
      data: {
        username,
        password,
      },
    },
  });

/**
 * @param {{
 *  username: string;
 *  password: string;
 *  firstName: string;
 *  lastName: string;
 *  }} props
 * @returns  {HttpResult<AuthResponse>}
 */
export const addUser = async ({ username, password, firstName, lastName }) =>
  httpService({
    url: `/auth/register/`,
    options: {
      method: "POST",
      data: {
        username,
        password,
        firstName,
        lastName,
      },
    },
  });

/**
 * @param {string} token
 * @returns  {HttpResult<AuthResponse>}
 */
export const confirmRegistration = async (token) =>
  httpService({
    url: "/auth/confirm-registration",
    options: {
      method: "POST",
      data: {
        token,
      },
    },
  });

/**
 * @param {string} token
 * @returns  {HttpResult<AuthResponse>}
 */
export const refresh = async (token) =>
  httpService({
    url: "/auth/refresh",
    options: {
      method: "POST",
      data: {
        token,
      },
    },
  });

/**
 * @returns  {HttpResult<string>}
 */
export const logout = async () =>
  httpService({
    url: "/auth/logout",
    options: {
      method: "POST",
    },
  });

/**
 * @param {{ token: string; }} props
 * @returns  {HttpResult<AuthResponse>}
 */
export const reissuePasswordChangeToken = async ({ token }) =>
  httpService({
    url: "/auth/reissue-password-change-token",
    options: {
      method: "POST",
      data: {
        token,
      },
    },
  });

/**
 * @param {{ email: string; }} props
 * @returns  {HttpResult<string>}
 */
export const sendResetPasswordLink = async ({ email }) =>
  httpService({
    url: "/auth/reset-password-request",
    options: {
      method: "POST",
      data: {
        email,
      },
    },
  });

/**
 * @param {string} otp
 * @returns  {HttpResult<string>}
 */
export const restoreSessionByCode = async (otp) =>
  httpService({
    url: "/auth/refresh-session-by-code",
    options: {
      method: "POST",
      data: {
        otp,
      },
    },
  });

/**
 * @param {{ oldPassword: string; newPassword: string; }} props
 * @returns  {HttpResult<string>}
 */
export const changePassword = async ({ oldPassword, newPassword }) =>
  httpService({
    url: "/users/change-password",
    options: {
      method: "PUT",
      data: {
        oldPassword,
        newPassword,
      },
    },
  });

/**
 * @param {{ token: string; password: string; }} props
 * @returns  {HttpResult<AuthResponse>}
 */
export const changePasswordByToken = async ({ token, password }) =>
  httpService({
    url: "/auth/reset-password",
    options: {
      method: "POST",
      data: {
        token,
        password,
      },
    },
  });
